export const locale = {
    lang: 'es',
    data: {
        NAVBAR_STYLE_2_TITLE: 'Modulo de Ventas',
    },
};
